<template lang="html">
  <div class="wysiwyg-field">
    <tiptap-vuetify
      ref="tiptap"
      v-model="content"
      :extensions="extensions"
      :native-extensions="nativeExtensions"
      :placeholder="placeholder"
    >
    </tiptap-vuetify>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * tiptap-vuetify WYSIWYG Editor
 *
 * !@NOTE: Current on-going issue, fixing the prosemirror-model loading
 * multiple versions (https://github.com/ueberdosis/tiptap/issues/577)
 * ==================================================================================
 **/

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from 'tiptap-vuetify'

export default {
  components: {
    TiptapVuetify
  },

  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Write the content here...'
    }
  },

  computed: {
    editor() {
      return this.$refs.tiptap ? this.$refs.tiptap.editor : null
    }
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.content = newValue
      }
    },
    content(newValue) {
      this.$emit('input', newValue)
    }
  },

  data: function() {
    return {
      extensions: [
        Italic,
        Bold,
        Underline,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ],
        Strike,
        Blockquote,
        Link,
        ListItem,
        BulletList,
        OrderedList,
        Code,
        HorizontalRule,
        History,
        Paragraph,
        HardBreak
      ],
      nativeExtensions: [],
      content: ``
    }
  }
}
</script>
<style type="text/css">
.tiptap-vuetify-editor .ProseMirror {
  min-height: 400px;
  max-height: 500px;
}
</style>
